import { background, radius, screen } from '@ebh/capsule/theme';

export default {
  wrapper: {
    position: 'fixed' as const,
    inset: 0,
    zIndex: 9999,
  },

  overlay: {
    position: 'absolute' as const,
    inset: 0,
    background: 'rgba(0,0,0,0.4)',
    opacity: 0,
    transition: 'opacity 0.3s ease',
  },

  overlayVisible: {
    opacity: 1,
    cursor: 'pointer',
  },

  sheet: [
    background('white'),
    {
      position: 'absolute' as const,
      boxShadow: '0px 10px 40px rgba(0,0,0,0.2)',
      transition: 'transform 0.3s ease, opacity 0.3s ease',
      opacity: 0,
    },
  ],

  visible: {
    transform: 'translate(0, 0)',
    opacity: 1,
  },

  right: [
    {
      top: 0,
      right: 0,
      height: '100%',
      width: '60%',
      transform: 'translateX(100%)',
    },
    screen('md', {
      width: '35%',
    }),
    radius(3, 'top-left'),
  ],

  left: [
    {
      top: 0,
      left: 0,
      height: '100%',
      width: '60%',
      transform: 'translateX(-100%)',
    },
    screen('md', {
      width: '35%',
    }),
    radius(3, 'top-right'),
  ],

  bottom: [
    {
      bottom: 0,
      left: 0,
      width: '100%',
      height: '70%',
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
      transform: 'translateY(100%)',
    },
    radius(3, 'top'),
  ],
  top: {
    top: 0,
    left: 0,
    width: '100%',
    height: '70%',
    transform: 'translateY(-100%)',
  },
};
